import { useMemo } from 'react';
import { GlobalBannerView } from '@frontend/global-info-banner';
import { useTranslation } from '@frontend/i18n';
import { usePhoneSettingsShallowStore } from '@frontend/phone-config';

interface AudioLibraryNotificationRibbonProps {
  onClose: () => void;
}

export const AudioLibraryNotificationRibbon: React.FC<AudioLibraryNotificationRibbonProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const { settingsTenantLocation } = usePhoneSettingsShallowStore('settingsTenantLocation');

  const bannerMessage = useMemo(
    () => t(`The Audio Library is shared across all locations in ${settingsTenantLocation?.name}.`),
    [t, settingsTenantLocation?.name]
  );

  return (
    <GlobalBannerView
      type='info'
      title={t('This is a Shared Library')}
      message={bannerMessage}
      onDismiss={onClose}
      trackingId='phone-callRecording-ribbon-close'
    />
  );
};
